import createVueComponent from '../createVueComponent';

const Baseline = createVueComponent('BaselineIcon', [
  ['path', { d: 'M4 20h16', key: '14thso' }],
  ['path', { d: 'm6 16 6-12 6 12', key: '1b4byz' }],
  ['path', { d: 'M8 12h8', key: '1wcyev' }],
]);

export default Baseline;
